import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { KeyboardPan } from "ol/interaction";

export default function KeyboardPanInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    condition: undefined,
    duration: undefined,
    pixelDelta: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, KeyboardPan, props, options, events),
    []
  );

  return null;
}
